var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    [
      _c(
        "md-card-header",
        { staticClass: "md-card-header-icon md-card-header-green" },
        [
          _c(
            "div",
            { staticClass: "card-icon icon-style" },
            [
              _c("md-icon", [_vm._v("inventory")]),
              _vm._v("\n            Services\n        "),
            ],
            1
          ),
        ]
      ),
      _c("md-card-content", [
        !_vm.services || _vm.services.length === 0
          ? _c("p", { staticClass: "grayedout-text text-center" }, [
              _vm._v("\n            No services found\n        "),
            ])
          : _c("div", [
              _c(
                "div",
                {
                  staticClass: "service-table-container",
                  class: { "with-scroll": _vm.enableScroll },
                },
                [
                  _c(
                    "md-table",
                    {
                      staticClass:
                        "context-menu-support custom-paginated-table",
                    },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c("md-table-head", [_vm._v("Service")]),
                          _c("md-table-head", [_vm._v("Description")]),
                          _c("md-table-head", [_vm._v("Quantity")]),
                          _c("md-table-head", [_vm._v("Actions")]),
                        ],
                        1
                      ),
                      _vm._l(_vm.services, function (service) {
                        return _c(
                          "md-table-row",
                          { key: service.serviceId },
                          [
                            _c("md-table-cell", [_vm._v(_vm._s(service.name))]),
                            _c("md-table-cell", [
                              _vm._v(_vm._s(service.description)),
                            ]),
                            _c(
                              "md-table-cell",
                              { staticClass: "quantity-column" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(service.quantity) +
                                    "\n                            "
                                ),
                                _c("span", { staticClass: "quantity-type" }, [
                                  _vm._v(_vm._s(service.quantityType)),
                                ]),
                              ]
                            ),
                            _vm.$root.isDesktop && !_vm.isReadOnlyUser
                              ? _c(
                                  "md-table-cell",
                                  { staticClass: "actions-column" },
                                  [
                                    !_vm.isReadOnlyUser
                                      ? _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-danger md-just-icon md-round",
                                            attrs: { title: "Delete service" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleDeleteService(
                                                  service.serviceId
                                                )
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
      ]),
      _vm.$root.isDesktop && !_vm.isReadOnlyUser
        ? _c(
            "md-card-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-success",
                  on: {
                    click: function ($event) {
                      return _vm.handleAddService()
                    },
                  },
                },
                [_vm._v("\n            Add Service\n        ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }